import { filter } from 'lodash';
import * as t from './actionTypes';

const initialState = {
    loadingActivities: true,
    loadingDetails: true,
    activities: [],
    myactivities: [],
    showall: false,
    selectedDetailActivity: {},
    selectedDetailActivityIsDirty: false,
    waitingactivities: [],
    delegatedactivities: [],
}

export default function (state = initialState, action) {
    switch (action.type) {
        case t.LOAD_ACTIVITIES:
            return Object.assign({}, state, {
                activities: action.payload
            });
        case t.DETAILS_LOADING:
            return Object.assign({}, state, {
                loadingDetails: action.payload,
            });
        case t.LOAD_ACTIVITYDETAILS:
            return Object.assign({}, state, {
                selectedDetailActivity: action.payload,
                selectedDetailActivityIsDirty: false
            });
        case t.ACTIVITIES_LOADING:
            return Object.assign({}, state, {
                loadingActivities: action.payload,
            });
        case t.SET_ACTIVITIES_SHOWALL:
            return Object.assign({}, state, {
                showall: action.payload
            });
        case t.SET_SELECTED_DETAIL_ACTIVITY_DIRTY:
            return Object.assign({}, state, {
                selectedDetailActivityIsDirty: action.payload
            });
        case t.LOAD_WAITING_ACTIVITIES:
            return Object.assign({}, state, {
                waitingactivities: action.payload,
                loadingActivities: false,
            });
        case t.LOAD_DELEGATED_ACTIVITIES:
            return Object.assign({}, state, {
                delegatedactivities: action.payload,
                loadingActivities: false,
            });
        case t.LOAD_MY_ACTIVITIES:
            return Object.assign({}, state, {
                myactivities: action.payload,
                loadingActivities: false,
            });
        default:
            return state
    }
}